import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../../Styles/PageStyles";
import Images from "../../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../../Config";
import { Select, MenuItem } from "@mui/material";
import { Formik, Form, Field } from "formik";
import { styled } from "@mui/material/styles";
import { FaUserPlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { FaBed } from "react-icons/fa";

const CustomSelect = styled(Select)({
    "& .MuiSelect-icon": {
        color: "#f59e0b",
    },
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
});


const Table = ({ ApiData }) => {
    const navigate = useNavigate();
    const [selectedRow, setSelectedRow] = useState(null);
    const [data, setData] = useState([]);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [currentPage, setCurrentPage] = useState(0);
    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };
    const ActionBtns = (item) => {
        return (
            <ActionBtnWrapper>
                <MenuItems title="Add Bed" onClick={() => {
                    navigate('/property/rooms');
                }}>
                    <FaBed className=" mr-1" />Add
                </MenuItems>
            </ActionBtnWrapper>
        );
    };

    useEffect(() => {
        if (ApiData) {
            const tempData = ApiData.map((item) => ({
                id: item.id,
                floor: getName(item.floor),
                noOfRoom: renderNoOfRoom(item),
                action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [ApiData]);

    const handleDropdownChange = (value, itemId) => {

    };

    const getName = (floor) => {
        return <p>Floor {floor}</p>;
    };

    const renderNoOfRoom = (item) => {
        if (item.noOfRoom > 0) {
            return (
                <div>
                    <input
                        type="text"
                        value={`${item.noOfRoom} Room${item.noOfRoom > 1 ? "s" : ""}`}
                        readOnly
                        className=" bg-amber-50 !rounded-lg !text-amber-500 !font-semibold text-[17px] w-28 items-center text-center"
                    />
                </div>
            );
        }
        else {
            return (
                <Formik
                    initialValues={{ noOfRoom: "" }}
                    onSubmit={() => { }}
                >
                    {({ setFieldValue, values }) => (
                        <Form>
                            <CustomSelect
                                value={values.noOfRoom}
                                displayEmpty
                                onChange={(e) => {
                                    setFieldValue("noOfRoom", e.target.value);
                                    handleDropdownChange(e.target.value, item.id);
                                }}
                                variant="outlined"
                                size="small"
                                className="bg-amber-50 !rounded-lg !text-amber-500 !font-medium"
                            >
                                <MenuItem value="" disabled>
                                    Select No. of Rooms
                                </MenuItem>
                                {Array.from({ length: 25 }, (_, i) => i + 1).map((num) => (
                                    <MenuItem key={num} value={num}>
                                        {num} Room{num > 1 ? "s" : ""}
                                    </MenuItem>
                                ))}
                            </CustomSelect>
                        </Form>
                    )}
                </Formik>
            );
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {

            return [
                {
                    Header: "Flat/Floor",
                    accessor: "floor",
                },
                {
                    Header: "No. of Rooms",
                    accessor: "noOfRoom",
                },

            ];
        }
        return [
            {
                Header: "Flat/Floor",
                accessor: "floor",
            },
            {
                Header: "No. of Rooms",
                accessor: "noOfRoom",
            },
            {
                Header: "Action",
                accessor: "action",
            },
        ];
    }, [isMobileView]);



    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex, pageSize },
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );


    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);
    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasData={ApiData?.length > 0}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps()} hasData={ApiData?.length > 0}>
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">

                                                <li>
                                                    <strong>Action:</strong> {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {ApiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};

const CustomTable = tw.table`w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasData ? "border-b" : "")}`;
const Tr = tw.tr`border-b rounded-md hover:bg-slate-50 cursor-pointer`;
const Th = tw.th`text-left text-xs md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-1 text-sm md:p-3 text-left`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const MenuItems = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-blue-500 border border-blue-500 hover:text-white rounded-lg text-blue-500`;
export default Table;
